export default "__VITE_ASSET__8b29c431__"